import { render, staticRenderFns } from "./WarningBar.vue?vue&type=template&id=25f6245f&scoped=true"
import script from "./WarningBar.vue?vue&type=script&lang=js"
export * from "./WarningBar.vue?vue&type=script&lang=js"
import style0 from "./WarningBar.vue?vue&type=style&index=0&id=25f6245f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f6245f",
  null
  
)

export default component.exports